import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Sheet from 'react-modal-sheet'
import { IconButton, Spinner, Typography } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { AiOutlinePlus } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { useAgamiRoutes } from '../hooks/useAgamiRoutes'
import Center from '../components/Center'
import { AddAgamiToExperienceTable } from './AddAgamiToExperienceTable'
import { AgamiSpot } from '../types/supabase'

interface AddAgamiToExperienceSheetProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  currentExpId: string
  isLoading: boolean
  agamiList: AgamiSpot[]
  refetchAfterChange: () => Promise<void>
}

export const AddAgamiToExperienceSheet: FC<AddAgamiToExperienceSheetProps> = ({
  isOpen,
  setIsOpen,
  currentExpId,
  isLoading,
  agamiList,
  refetchAfterChange,
}) => {
  const navigate = useNavigate()
  const { newAgamiPath } = useAgamiRoutes()
  const { t } = useTranslation()

  return (
    <Sheet isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Sheet.Container>
        <Sheet.Header className="p-4 flex justify-between items-center">
          <Typography variant="h4">{t('addAgamiToExperience.title')}</Typography>
        </Sheet.Header>
        <Sheet.Content>
          {isLoading && (
            <Center>
              <Spinner className="h-6 w-6 my-4" />
            </Center>
          )}

          {!isLoading && agamiList.length === 0 && <span>{t('addAgamiToExperience.noAgamiYet')}</span>}

          <div className="mx-2 my-3 pb-3 flex items-center justify-between border-b">
            <Typography variant="h5" color="gray">
              {t('addAgamiToExperience.createNewAgami')}
            </Typography>
            <IconButton
              size="md"
              color={'primary' as colors}
              className="rounded-full w-8 h-8"
              onClick={() =>
                navigate(newAgamiPath(currentExpId), {
                  state: { returnTo: `/experiences/${currentExpId}` },
                })
              }
            >
              <AiOutlinePlus className="w-4 h-4" />
            </IconButton>
          </div>

          {!isLoading && agamiList.length > 0 && (
            <div className="px-2 overflow-y-scroll">
              <Typography variant="h5" color="gray">
                {t('addAgamiToExperience.addFromLibrary')}
              </Typography>
              <AddAgamiToExperienceTable
                currentExpId={currentExpId}
                refetchAfterChange={refetchAfterChange}
                agamiList={agamiList}
              />
            </div>
          )}
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  )
}
